import { Pipe, PipeTransform } from '@angular/core';
import { ReportStatus } from './requested-reports.component';

@Pipe({
  name: 'reportStatusToTooltip',
})
export class ReportStatusToTooltipPipe implements PipeTransform {
  transform(value: ReportStatus): string {
    switch (value) {
      case ReportStatus.READY:
        return 'Report is ready to be downloaded!';
      case ReportStatus.PAYMENT_ERROR:
        return (
          'Please try to request the report again.' +
          ' Probably, several payments were made at the same time,' +
          ' so we could not process them. If you have any questions, please contact us.'
        );
      default:
        return (
          'We are working on it.' + 'Link to the report will be available soon'
        );
    }
  }
}
